// src/theme.js
import { extendTheme } from '@chakra-ui/react';

const customTheme = extendTheme({
  colors: {
    primary: '#212630',
    secondary: '#304050',
    text: '#676A6C',
    accent: '#3E8FFA',
    background: '#F3F6FB',
    highlight: '#F5D409',
    blueHighlight: '#34BFFF',
    button: '#4760F6',
    deepBlue: '#0B2777',
    orange: '#F1800D',
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'normal', // Adjust the weight as needed
      },
      variants: {
        solid: (props) => ({
          bg: props.colorMode === 'dark' ? 'button' : 'button',
          color: 'white',
        }),
      },
    },
    Text: {
      baseStyle: {
        color: 'text',
      },
    },
    // You can continue to customize other components as needed
  },
});

export default customTheme;